import React, { PropTypes } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { StyledCheckboxInput, DayPicker, SelectInput, TextInput } from "../common/form";
import validationUtils from "../../utils/ValidationUtils";
import { MessageBox } from "../common";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import { Field, reduxForm, change as changeFieldValue, formValueSelector } from "redux-form";

import genders from "../dashboard/clients/client/members/enums/genders";
import { LANGUAGE_CODES, COUNTRIES, PROVINCES } from "../../utils/enums/enums";
import { EnumWrapper } from "../../utils/enums";
import { Button } from "react-bootstrap";
import Recaptcha from "react-recaptcha";
import config from "config";
import { personalDataMemberValidationRules } from "./personalDataMemberValidationRules";

class PersonalDataMemberForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.updateCaptcha = this.updateCaptcha.bind(this);
    }

    componentWillMount() {
        const { languageCode } = this.props;
        if (!document.getElementById("reCaptchaV2")) {
            const script = document.createElement("script");
            script.id = "reCaptchaV2";
            script.src = `https://www.google.com/recaptcha/api.js?render=explicit&hl=${languageCode}`;
            script.async = true;
            script.defer = true;
            document.body.appendChild(script);
        }
    }

    updateCaptcha(value) {
        this.props.changeFieldValue("personalDataMemberForm", "gRecaptchaResponse", value || null);
    }

    render() {
        const { fieldsToShow, handleSubmit, gRecaptcha, submitComplete, countryCode, checkCodeValidity } = this.props;
        const personalInfoObjProps = [
            "firstName",
            "lastName",
            "phoneNumber",
            "emailAddress",
            "birthdate",
            "memberGenderType",
            "languageCode",
        ];

        const postalInfoObjProps = ["address", "city", "countryCode", "provinceCode", "postalCode"];

        let hasPersonalInfoKey = false;
        let hasPostalInfoKey = false;

        personalInfoObjProps.forEach((elem) => {
            if (fieldsToShow.hasOwnProperty(elem)) {
                hasPersonalInfoKey = true;
                return hasPersonalInfoKey;
            }
        });
        
        postalInfoObjProps.forEach((elem) => {
            if (fieldsToShow.hasOwnProperty(elem)) {
                hasPostalInfoKey = true;
                return hasPostalInfoKey;
            }
        });

        const maxDate = moment.utc();
        return (
            <form onSubmit={handleSubmit}>
                <h4 className="mt-1">
                    <FormattedMessage id="personalData.form.pleaseVerify" />
                </h4>
                <MessageBox className="alert-info bg-transparent">
                    <FormattedMessage id="personalData.form.pleaseVerifyInfo" />
                </MessageBox>
                <MessageBox className="alert-info bg-transparent">
                    <FormattedMessage id="personalData.form.checkCodeValidity" values={{ time: checkCodeValidity }} />
                </MessageBox>
                
                <div>
                    <div className="member-personal-data-form-flex">
                        {hasPersonalInfoKey && (
                            <div className="member-info-section-form">
                                <h4>
                                    <b>
                                        <FormattedMessage id="personalData.form.personalInfoTitle" />
                                    </b>
                                </h4>
                                {fieldsToShow.firstName && (
                                    <Field
                                        id="firstName"
                                        name="firstName"
                                        component={TextInput}
                                        disabled={submitComplete}
                                        label={<FormattedMessage id="personalData.form.firstName" />}
                                    />
                                )}
                                {fieldsToShow.lastName && (
                                    <Field
                                        id="lastName"
                                        name="lastName"
                                        component={TextInput}
                                        disabled={submitComplete}
                                        label={<FormattedMessage id="personalData.form.lastName" />}
                                    />
                                )}
                                {fieldsToShow.phoneNumber && (
                                    <Field
                                        id="phoneNumber"
                                        name="phoneNumber"
                                        component={TextInput}
                                        disabled={submitComplete}
                                        label={<FormattedMessage id="personalData.form.phoneNumber" />}
                                    />
                                )}
                                {fieldsToShow.emailAddress && (
                                    <Field
                                        id="emailAddress"
                                        name="emailAddress"
                                        component={TextInput}
                                        disabled={submitComplete}
                                        label={<FormattedMessage id="personalData.form.email" />}
                                    />
                                )}
                                {fieldsToShow.birthdate && (
                                    <Field
                                        id="birthdate"
                                        name="birthdate"
                                        component={DayPicker}
                                        maxDate={maxDate}
                                        disabled={submitComplete}
                                        label={<FormattedMessage id="personalData.form.birthDate" />}
                                    />
                                )}
                                {fieldsToShow.memberGenderType && (
                                    <Field
                                        id="memberGenderType"
                                        name="memberGenderType"
                                        component={SelectInput}
                                        label={<FormattedMessage id="personalData.form.gender" />}
                                        disabled={submitComplete}
                                        options={genders}
                                    />
                                )}
                                {fieldsToShow.languageCode && (
                                    <EnumWrapper enum={LANGUAGE_CODES} format="inputs" prop="options">
                                        <Field
                                            id="languageCode"
                                            name="languageCode"
                                            component={SelectInput}
                                            disabled={submitComplete}
                                            label={<FormattedMessage id="personalData.form.language" />}
                                        />
                                    </EnumWrapper>
                                )}
                            </div>
                        )}
                        <div className="member-info-section-form">
                            {hasPostalInfoKey && (
                                <div>
                                    <h4>
                                        <b>
                                            <FormattedMessage id="personalData.form.postalInfoTitle" />
                                        </b>
                                    </h4>
                                    {fieldsToShow.address && (
                                        <Field
                                            id="address"
                                            name="address"
                                            component={TextInput}
                                            disabled={submitComplete}
                                            label={<FormattedMessage id="personalData.form.address" />}
                                        />
                                    )}
                                    {fieldsToShow.city && (
                                        <Field
                                            id="city"
                                            name="city"
                                            component={TextInput}
                                            disabled={submitComplete}
                                            label={<FormattedMessage id="personalData.form.city" />}
                                        />
                                    )}
                                    {fieldsToShow.countryCode && (
                                        <EnumWrapper enum={COUNTRIES} format="inputs" prop="options">
                                            <Field
                                                id="countryCode"
                                                name="countryCode"
                                                component={SelectInput}
                                                disabled={submitComplete}
                                                label={<FormattedMessage id="personalData.form.country" />}
                                            />
                                        </EnumWrapper>
                                    )}
                                    {fieldsToShow.provinceCode && (
                                        <EnumWrapper
                                            enum={PROVINCES}
                                            query={`filters=provinces.countryCode==${countryCode}`}
                                            format="inputs"
                                            prop="options"
                                        >
                                            <Field
                                                id="provinceCode"
                                                name="provinceCode"
                                                component={SelectInput}
                                                disabled={submitComplete}
                                                label={<FormattedMessage id="personalData.form.province" />}
                                            />
                                        </EnumWrapper>
                                    )}

                                    {fieldsToShow.postalCode && (
                                        <Field
                                            id="postalCode"
                                            name="postalCode"
                                            component={TextInput}
                                            disabled={submitComplete}
                                            label={<FormattedMessage id="personalData.form.postalCode" />}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="mt-1">
                    <Field
                        id="legalText"
                        name="legalText"
                        type="checkbox"
                        component={StyledCheckboxInput}
                        disabled={submitComplete}
                        checkbox={{ value: true }}
                        label={<FormattedHTMLMessage id="personalData.form.legalText" />}
                    />
                    <Field
                        id="legalTextIdentity"
                        name="legalTextIdentity"
                        type="checkbox"
                        component={StyledCheckboxInput}
                        disabled={submitComplete}
                        checkbox={{ value: true }}
                        label={<FormattedHTMLMessage id="personalData.form.legalTextIdentity" />}
                    />
                    <Field
                        id="legalTextDataUsage"
                        name="legalTextDataUsage"
                        type="checkbox"
                        component={StyledCheckboxInput}
                        disabled={submitComplete}
                        checkbox={{ value: true }}
                        label={<FormattedHTMLMessage id="personalData.form.legalTextDataUsage" />}
                    />
                    <Field
                        id="legalTextDelay"
                        name="legalTextDelay"
                        type="checkbox"
                        component={StyledCheckboxInput}
                        disabled={submitComplete}
                        checkbox={{ value: true }}
                        label={<FormattedHTMLMessage id="personalData.form.legalTextDelay" />}
                    />
                    <br />
                    <Recaptcha
                        sitekey={config.recaptchaApiKey}
                        render="explicit"
                        expiredCallback={this.updateCaptcha}
                        verifyCallback={this.updateCaptcha}
                        onloadCallback={() => {
                            /*will not load if this is not defined*/
                        }}
                    />
                    <Field id="gRecaptchaResponse" name="gRecaptchaResponse" component={() => <span />} />
                </div>
                <Button disabled={!gRecaptcha || submitComplete} type="submit" className="btn btn-lg btn-primary mt-1">
                    <FormattedMessage id="personalData.form.submitBtn" />
                </Button>
            </form>
        );
    }
}

PersonalDataMemberForm.propTypes = {
    changeFieldValue: PropTypes.func,
    fieldsToShow: PropTypes.object,
    submitComplete: PropTypes.bool,
    onSubmit: PropTypes.func,
    languageCode: PropTypes.string,
    handleSubmit: PropTypes.func,
    gRecaptcha: PropTypes.string,
    countryCode: PropTypes.string,
    checkCodeValidity: PropTypes.number,
};

function mapStateToProps(state) {
    const form = formValueSelector("personalDataMemberForm");

    return {
        gRecaptcha: form(state, "gRecaptchaResponse"),
        countryCode: form(state, "countryCode") || "CA",
    };
}

function mapDispatchToProps(dispatch) {
    return {
        changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps, null, {
    withRef: true,
})(
    reduxForm({
        form: "personalDataMemberForm",
        validate: (values) => validationUtils.validate(values, personalDataMemberValidationRules),
    })(PersonalDataMemberForm)
);



// WEBPACK FOOTER //
// ./src/components/personal-data/PersonalDataMemberForm.js